import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { IngestionApiService } from '../../../services/ingestion-api.service';
import { Document, MetadataDocument } from '../../../models/document.model';
import { StatusEnumDocument } from '../../../enum/status-document.enum';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'app-upload-dialog-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, ButtonModule, InputTextModule, TextareaModule, DividerModule],
  templateUrl: './upload-dialog-detail.component.html',
  styleUrl: './upload-dialog-detail.component.scss',
})
export class UploadDialogDetailComponent implements OnChanges {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() document!: Document;

  formData: Partial<MetadataDocument> & { keywordsStr?: string } = {};

  readonly urlPattern = '^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$';
  readonly yearPattern = '^[0-9]{4}$';

  private ingestionApi = inject(IngestionApiService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['document'] && this.document?.metadata) {
      this.formData = { ...this.document.metadata };
      if (this.document.metadata.keywords) {
        this.formData.keywordsStr = this.document.metadata.keywords.join(', ');
      }
    }
  }

  onSave() {
    const updatedKeywords = this.formData.keywordsStr
      ? this.formData.keywordsStr
          .split(',')
          .map((k) => k.trim())
          .filter((k) => k.length > 0)
      : [];

    const updatedMetadata: MetadataDocument = {
      ...(this.document.metadata || ({} as MetadataDocument)),
      category: this.formData.category || '',
      description: this.formData.description || '',
      link: this.formData.link || '',
      year_of_publication: this.formData.year_of_publication || '',
      keywords: updatedKeywords,
      latest: this.formData.latest ?? this.document.metadata?.latest ?? 'false',
      timestamp: new Date().toISOString(),
    };

    const payload: Document = {
      document_id: this.document.document_id,
      metadata: updatedMetadata,
      status: StatusEnumDocument.READY,
      updated_at: new Date().toISOString(),
    };

    this.ingestionApi.updateDocument(payload);
    this.closeDialog();
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
